export default function parseShort(subject, number) {
    if (subject.length > number - 3) {
        return `${subject.substring(0, number)}...`;
    }
    return subject;
}
